import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const SECTIONS = [
  {
    title: '1. Acceptance of terms',
    body: 'By accessing or booking through LocalKonnect you agree to these Terms & Conditions. If you do not agree, please do not use the platform.',
  },
  {
    title: '2. Bookings & tickets',
    body: 'A booking is confirmed only after successful payment. Tickets are issued for the specific event, date, and seat/tier selected and are subject to the organizer’s entry rules. Please arrive with a valid ticket (QR) and any age or ID requirements stated on the event.',
  },
  {
    title: '3. Pricing & payments',
    body: 'All prices are shown in Indian Rupees and include applicable taxes and platform/service fees where stated. The amount displayed at checkout is the amount charged. Payments are handled securely by Razorpay.',
  },
  {
    title: '4. Cancellations & refunds',
    body: 'Cancellations are governed by the event’s cancellation policy shown at checkout. Where a refund applies, it is processed to the original payment method within standard banking timelines. Convenience or service fees may be non-refundable. Event organizers may reschedule or cancel events; in such cases we will assist with refunds per policy.',
  },
  {
    title: '5. User conduct',
    body: 'You agree to provide accurate information, not to resell tickets without authorization, and not to misuse the platform. We may suspend accounts involved in fraud or abuse.',
  },
  {
    title: '6. Limitation of liability',
    body: 'LocalKonnect is a marketplace connecting you with event organizers. We are not responsible for the conduct of an event itself, but we will make reasonable efforts to support you if something goes wrong.',
  },
  {
    title: '7. Changes',
    body: 'We may update these terms from time to time. Continued use after changes constitutes acceptance of the revised terms.',
  },
  {
    title: '8. Contact',
    body: 'For any questions, email info@localkonnect.com or call +91 9571364889.',
  },
];

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-surface-muted">
      <Header />
      <main className="flex-1">
        <div className="border-b border-ink-200/70 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            <h1 className="text-h1 text-ink-900">Terms &amp; Conditions</h1>
            <p className="mt-1 text-sm text-ink-500">Last updated: 19 August 2026</p>
          </div>
        </div>
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <p className="text-ink-700 leading-relaxed mb-8">
            These terms govern your use of the LocalKonnect events platform. Please read them
            carefully before making a booking.
          </p>
          <div className="space-y-8">
            {SECTIONS.map((s) => (
              <section key={s.title}>
                <h2 className="text-lg font-semibold text-ink-900 mb-2">{s.title}</h2>
                <p className="leading-relaxed text-ink-700">{s.body}</p>
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
